module.exports = __webpack_public_path__ + "img/santa-fe-25.3babad74.png";